'use client';
import { ThemeContext } from '@susu/custom-made/providers';
import { useContext, useEffect, useState } from 'react';

import Panel, { PanelSize, PanelType } from '../../panel/panel';
import { OnBoardingPanel } from '../onBoardingPanel/onBoardingPanel';
import Avo from '@susu/custom-made/Avo';
import { getAvoEventParams } from '@susu/custom-made/utils/utils';

export const OnBoardingContainer = () => {
  const { state } = useContext(ThemeContext);
  const [isShown, setIsShown] = useState<boolean>(false);
  const visitedStorageName = 'cm_visited_products';
  const onBoardingTexts = [
    'Your perfect suit in 4 simple steps',
    'Choose from our finest Italian fabrics',
    'Pick your style',
    'Make it unique',
    'Get your perfect fit with just a click',
  ];

  const startDesignClick = () => {
    setIsShown(false);
    Avo.customMadeDesigningStarted(getAvoEventParams(state));
  }

  const overlayExitClick = () => {
    setIsShown(false);
    Avo.customMadeOverlayExited(getAvoEventParams(state));
  }

  useEffect(() => {
    const currentProduct = state.product as string;
    const visitedProductStorage = localStorage.getItem(visitedStorageName);
    if (!visitedProductStorage || visitedProductStorage.split(',').indexOf(currentProduct) === -1) {
      setIsShown(true);

      let visitedProductArray = [currentProduct];
      if (visitedProductStorage) {
        visitedProductArray = [...visitedProductStorage.split(','), ...visitedProductArray];
      }
      localStorage.setItem(visitedStorageName, visitedProductArray.join(','));
    }
  }, []);

  return (
    <Panel
      isActive={isShown}
      closeClick={overlayExitClick}
      panelSize={PanelSize.Full}
      hasCloseBtn={true}
      withOverlay={true}
      panelType={PanelType.MiddleScreen}
    >
      {isShown &&
        <OnBoardingPanel
          title={onBoardingTexts}
          ctaClick={startDesignClick}
          ctaText="Start designing"
          stepAmount={5}
        />
      }
    </Panel>
  );
};
